import { FormValidityObserver as SharedFormValidityObserver } from '../../../dapp-form/FormValidityObserver';

interface FormValidityObserverProps {
  onValidityChange?: (isValid: boolean) => void;
  hasDappIcon: boolean;
  hasPreviewImages: boolean;
}

export function FormValidityObserver({
  onValidityChange,
  hasDappIcon,
  hasPreviewImages,
}: FormValidityObserverProps) {
  return (
    <SharedFormValidityObserver
      onValidityChange={onValidityChange}
      isExtraValid={hasDappIcon && hasPreviewImages}
    />
  );
}
